
import { defineComponent, PropType, ref, toRefs, watch, reactive } from "vue";

import { CommentModel, CommentTargetType } from "@/typings";
import { UserTag, StyleTag } from "@/components/common";
import { formatTS } from "@/utility";
import markdown from "@/markdown/renderMD";

export default defineComponent({
    components: {
        UserTag,
    },
    props: {
        comment: {
            type: Object as PropType<CommentModel>,
            required: true,
        },
        targetType: {
            type: String as PropType<CommentTargetType>,
            required: true,
            default: "ALBUM",
        },
    },
    setup(props) {
        const { comment } = toRefs(props);

        return {
            formatTS,
            markdown,
        };
    },
});
